import { API_ENDPOINTS } from '../constants/api-endpoints';
import { API } from './api-config';

const {
  APPEALS: { FIND_ALL, CREATE_ONE, GET_LATEST, CONFIRM_ONE, DECLINE_ONE },
} = API_ENDPOINTS;

export const ApiAppeal = {
  fetchAll: (params?: Record<string, any>) => {
    return API({
      path: FIND_ALL,
      method: 'GET',
      params,
    });
  },
  createOne: (data: Record<string, any>) => {
    return API({
      path: CREATE_ONE,
      method: 'POST',
      data,
    });
  },
  getCurrent: () => {
    return API({
      path: GET_LATEST,
      method: 'GET',
    });
  },
  confirm: (data: Record<string, any>) => {
    return API({
      path: CONFIRM_ONE,
      method: 'POST',
      data,
    });
  },
  decline: (data: Record<string, any>) => {
    return API({
      path: DECLINE_ONE,
      method: 'POST',
      data,
    });
  },
};
